import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { GetSurveysDto, SurveyDto } from './dtos/survey.dto';
import { GetSurveyPayloadMapper } from './mapper/survey-payload.mapper';
import { Survey } from '../models/survey.model';
import { GetSurveysMapper } from './mapper/survey.mapper';

@Injectable({ providedIn: 'root' })
export class SurveyApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}`;
  private readonly _payloadMapper = new GetSurveyPayloadMapper();
  private readonly _mapper = new GetSurveysMapper();

  public getSurveys(data: GetSurveysDto): Observable<Survey[]> {
    const params = this._payloadMapper.toPayload(data);
    return this._http
      .get<SurveyDto[]>(`${this._baseUrl}/buyers/v2/surveys?UI=1`, { params })
      .pipe(map((surveys) => this._mapper.fromDtoList(surveys)));
  }
}
